import { Badge } from '@/components/ui/badge'
import type { IntegrationOverviewCredential } from '@/types/integrations'

export function OverallHealthBadge({ credentials }: { credentials: IntegrationOverviewCredential[] }) {
  if (credentials.length === 0) return <Badge variant="outline">No locations</Badge>

  const activeCredentials = credentials.filter(c => c.is_active)
  if (activeCredentials.length === 0) return <Badge variant="outline">Disabled</Badge>

  const hasCircuitBroken = activeCredentials.some(c => c.health_status === 'circuit_broken')
  if (hasCircuitBroken) return <Badge variant="destructive">Error</Badge>

  const hasDegraded = activeCredentials.some(c => c.health_status === 'degraded' || c.health_status === 'stale')
  if (hasDegraded) return <Badge variant="secondary">Warning</Badge>

  const allHealthy = activeCredentials.every(c => c.health_status === 'healthy')
  if (allHealthy) return <Badge variant="default">Connected</Badge>

  return <Badge variant="outline">Pending</Badge>
}
